import { cn } from "@omni/utils/styles";

import { useEnergyLabelContext } from "@/components/Product/energyLabel/context/energyLabel.context";
import { getImageRendition } from "@/components/Product/energyLabel/utils";
import {
    useBreakpoint,
    withBreakpoints
} from "@/utils/breakpoints/breakpoints.provider";

type Props = {
    className?: string;
};

const _Label = ({ className }: Props) => {
    const { breakpoints } = useBreakpoint();

    const energyLabel = useEnergyLabelContext();

    if (!energyLabel.label) return null;

    const src = energyLabel.eprel
        ? energyLabel.label
        : getImageRendition(energyLabel.label, false, breakpoints);

    return (
        <img
            className={cn(
                "tw:h-auto tw:w-full tw:max-h-[80dvh] tw:object-contain",
                className
            )}
            src={src}
            alt={energyLabel.altText}
        />
    );
};

export const Label = withBreakpoints(_Label);
